import clsx from "clsx";
import React, { memo } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

import type { WithChildren } from "../../../_metronic/helpers";
import { checkIsActive } from "../../../_metronic/helpers";
import { ExternalLinkIcon } from "../icons";

interface Props {
  to: string;
  title: string;
  iconComponent?: React.ReactNode;
  external?: boolean;
}

const SidebarMenuItem: React.FC<Props & WithChildren> = memo(
  ({ children, to, title, iconComponent, external }) => {
    const { pathname } = useLocation();
    const isActive = checkIsActive(pathname, to);

    if (external) {
      return (
        <div className="menu-item">
          <a
            className="menu-link without-sub"
            href={to}
            target="_blank"
            rel="noopener noreferrer"
          >
            {iconComponent && (
              <span className="menu-icon">{iconComponent}</span>
            )}
            <span className="menu-title">
              {title}&nbsp;
              <ExternalLinkIcon />
            </span>
          </a>
        </div>
      );
    }
    return (
      <div className="menu-item">
        <Link
          className={clsx("menu-link without-sub", { active: isActive })}
          to={to}
        >
          {iconComponent && <span className="menu-icon">{iconComponent}</span>}
          <span className="menu-title">{title}</span>
        </Link>
        {children}
      </div>
    );
  },
);

export { SidebarMenuItem };
